<template>
  <div class="background-white container-wrapper" v-if="pageLoadingComplete">
    <div class="card" v-if="has_express === 1" @click="toAddressEdit()">
      <div class="card-content">
        <div class="address container">
          <div class="address-content">
            <div class="address-edit" v-if="addrList.length > 0">
              <p class="name">
                <span>{{ currentAddress.consignee }}</span>
                <span>{{ currentAddress.phone }}</span>
              </p>
              <p class="text">
                {{ currentAddress.text }}
                {{ currentAddress.address }}
              </p>
            </div>
            <div class="address-add" v-else>
              <p class="name">
                <img :src="getCurrentBrand.imageGoodsLocal" class="icon" />
                <span>请填写收货人信息</span>
              </p>
            </div>
          </div>
          <van-icon name="arrow" />
        </div>
      </div>
    </div>

    <div class="card">
      <div class="card-title">商品信息</div>
      <div class="card-content">
        <ul class="infor-list container">
          <li v-for="(item, index) in products" :key="index">
            <div class="infor-list-item">
              <p class="name">
                <span class="lable">{{ item.type_name }}</span>
                <span class="text">{{ item.name }}</span>
              </p>
              <p class="detail">
                <span class="text">￥{{ item.amount }}</span>
                <span class="text">数量：{{ item.count }}</span>
              </p>
            </div>
          </li>
        </ul>
      </div>
    </div>
    <div class="card">
      <div class="card-content">
        <van-cell-group class="ksii-group container" :border="false">
          <van-cell title="商品金额" :value="'￥' + clearPriceZero(total.amount)" :border="false" />
          <van-cell
            v-if="total.express_fee && total.express_fee !== '0' && total.express_fee !== '0.00'"
            title="运费"
            :value="'￥' + clearPriceZero(total.express_fee)"
            :border="false"
          />
          <van-cell
            v-if="has_coupons === 1"
            title="优惠券"
            :value="total.cost_coupons !== '0.00' ? '-￥' + clearPriceZero(total.cost_coupons) : ''"
            :border="false"
            @click="showCouponsPicker = true"
          >
            <template #right-icon v-if="total.cost_coupons === '0.00'">
              <div class="grey">
                <span v-if="isMyCoupon" style="color: #333">有可用</span>
                <span v-else>无可用</span>
                <img
                  src="../../assets/images/goods/catalog_series_course_buy_arrow.png"
                  class="grey-img"
                />
              </div>
            </template>
          </van-cell>
          <van-cell
            v-if="has_recommend === 1"
            title="推荐码"
            :value="total.cost_discount !== '0' ? '-￥' + clearPriceZero(total.cost_discount) : ''"
            :border="false"
            @click="showCodePicker = true"
          >
            <template #right-icon v-if="total.cost_discount === '0'">
              <div class="grey">
                <span>去填写</span>
                <img
                  src="../../assets/images/goods/catalog_series_course_buy_arrow.png"
                  class="grey-img"
                />
              </div>
            </template>
          </van-cell>
          <van-cell
            title="代金券"
            v-if="total.cost_coupon !== '0' && total.cost_coupon !== '0.00'"
            :value="'-￥' + clearPriceZero(total.cost_coupon)"
            :border="false"
          />
          <van-cell
            title="余额支付"
            v-if="clearPriceZero(total.cost_balance) !== '0'"
            :value="'-￥' + clearPriceZero(total.cost_balance)"
            :border="false"
          />
          <van-cell title="合计" :border="false">
            <template #right-icon>
              <div class="price">
                <span class="symbol">￥</span>
                <span class="number">{{ clearPriceZero(total.cost_payment) }}</span>
              </div>
            </template>
          </van-cell>
        </van-cell-group>
      </div>
    </div>
    <div class="card" v-if="hasPaymentAmount">
      <div class="card-title">支付方式</div>
      <div class="card-content">
        <van-radio-group v-model="playTypeRsult" class="playtype">
          <van-cell-group :border="false">
            <van-cell
              v-for="item in playTypeListArray"
              clickable
              :key="item.value"
              :title="`${item.name}`"
              :icon="item.icon"
              :border="false"
              @click="playTypeRsult = item.value"
            >
              <template #right-icon>
                <van-radio :name="item.value" checked-color="#07c160" />
              </template>
            </van-cell>
          </van-cell-group>
        </van-radio-group>
      </div>
    </div>
    <div class="card">
      <div class="card-title">说明</div>
      <div class="card-content">
        <div class="explain container">
          <p class="explain-text">
            1.若订单商品支持余额支付，将优先扣除账户余额，余额不 足的部分需额外充值
          </p>
          <p class="explain-text">{{ paymentExplainText }}</p>
        </div>
      </div>
    </div>
    <div class="play-button container">
      <van-button round type="primary" class="button" @click="buy()" :disabled="isDisableButton">
        支付￥{{ clearPriceZero(total.cost_payment) }}
      </van-button>
    </div>
    <van-dialog
      class="dialog-pay"
      v-model="showDialog"
      title="请确认支付是否完成?"
      :showConfirmButton="false"
      :show-cancel-button="false"
    >
      <van-button round type="primary" class="button" @click="finishButtonClick">
        已完成支付
      </van-button>
      <!-- <div class="button button-kefu">
        支付遇到问题，<span class="text">联系客服</span>
      </div> -->
      <img
        src="../../assets/images/common/dialog_colse_white_round.png"
        class="close close-icon"
        @click="showDialog = false"
      />
    </van-dialog>
    <!-- 邀请码填写 -->
    <CodePicker
      ref="codePicker"
      :show="showCodePicker"
      :orderPrepareParam="orderPrepareFixedParam()"
      @update="updateRecommendCode"
      @onClose="showCodePicker = false"
    ></CodePicker>
    <!-- 优惠券选择 -->
    <CouponsPicker
      :show="showCouponsPicker"
      :orderPrepareParam="orderPrepareFixedParam()"
      :selectedCoupons="couponsArray"
      @update="updateCouponsArray"
      @onClose="showCouponsPicker = false"
    ></CouponsPicker>
  </div>
</template>

<script>
// const wx = require('../../plugins/wxsdk.js')

import { orderPrepare, orderCreatePayment, checkPaymentResult } from '@/api/order'
import { jsApiCall } from '@/utils/jsApi'
import { addressList } from '@/api/address'
import {
  getShoppingInfor,
  getPaySuccessURL,
  getPayOrderNo,
  setPayOrderNo,
  removePayOrderNo,
  removeShoppingInfor,
  getToken,
  getRequestAppType,
  setPayProducts,
} from '@/utils/cookies'

import CodePicker from './components/Code.vue'
import CouponsPicker from './components/Coupons.vue'

import codeCoupoonsMixin from '@/views/pay/mixins/codeCoupoons'

import { mapGetters } from 'vuex'

export default {
  components: { CodePicker, CouponsPicker },
  mixins: [codeCoupoonsMixin],
  data() {
    return {
      playTypeList: {
        zfb: {
          name: '支付宝',
          value: 'zfb',
          icon: 'https://appresource-1253756937.cos.ap-chengdu.myqcloud.com/skb/common/icon/alipay.png',
        },
        wxwap: {
          name: '微信',
          value: 'wxwap',
          icon: 'https://appresource-1253756937.cos.ap-chengdu.myqcloud.com/skb/common/icon/weixin.png',
        },
        wxh5: {
          name: '微信',
          value: 'wxh5',
          icon: 'https://appresource-1253756937.cos.ap-chengdu.myqcloud.com/skb/common/icon/weixin.png',
        },
        wxmini: {
          name: '微信',
          value: 'wxmini',
          icon: 'https://appresource-1253756937.cos.ap-chengdu.myqcloud.com/skb/common/icon/weixin.png',
        },
      },
      playTypeRsult: '',
      paymentParam: {
        // 支付宝
        zfb: { paymentmethod: 'wap_alipay', os: 'wap', trade: 'wap' },
        // 微信内部浏览器
        wxwap: { paymentmethod: 'wap_weixin', os: 'wap', trade: 'jsapi' },
        // 微信外部浏览器
        wxh5: { paymentmethod: 'wap_weixin', os: 'wap', trade: 'h5' },
        //微信小程序
        wxmini: { paymentmethod: 'wap_weixin', os: 'mp', trade: 'mini' },
      },

      currentContact: {
        name: '请填写收货人信息',
      },
      // 地址列表
      addrList: [],

      products: [],
      total: { amount: 0 },

      selectAddressId: this.$store.state.address.select_id,

      pageLoadingComplete: false,

      // 用户支付成功后的跳转地址
      paymentSuccessURL: '',

      // 用户支付后的回调地址
      paymentCallURL: '',

      // 显示弹窗
      showDialog: false,

      // 是否禁用按钮
      isDisableButton: false,

      // 结果轮询定时器
      resultSelectTimer: false,

      has_express: 0, //是否有快递，0 没有， 1有

      has_coupons: 0, //是否可以使用优惠券
      has_recommend: 0, //还是可以使用推荐码
    }
  },
  computed: {
    clearPriceZero() {
      return (number) => this.$util.clearPriceZero(number)
    },
    hasPaymentAmount() {
      return Number(this.total.cost_payment) > 0
    },
    currentAddress() {
      let o = null,
        selectAddressId = this.selectAddressId,
        addrList = this.addrList
      addrList.forEach((item) => {
        if (item.id === selectAddressId) {
          o = item
        }
      })
      return o || addrList[0]
    },

    isJbcShanganBrand() {
      return this.getCurrentBrand?.brandKey === 'jbcshangan'
    },

    isJbcZsbBrand() {
      return this.getCurrentBrand?.brandKey === 'jbczsb'
    },

    paymentExplainText() {
      if (this.isJbcShanganBrand) {
        return this.$browser.isWXBrowser()
          ? '2.若订单商品不支持余额支付，需使用微信直接支 付购买'
          : '2.若订单商品不支持余额支付，需使用支付宝直接支 付购买'
      }
      return this.isJbcZsbBrand && !this.$browser.isWXBrowser()
        ? '2.若订单商品不支持余额支付，需使用支付宝直接支 付购买'
        : '2.若订单商品不支持余额支付，需使用微信或支付宝直接支 付购买'
    },

    playTypeListArray() {
      let list = this.playTypeList,
        result = []
      // 微信浏览器
      if (this.$browser.isWXBrowser()) {
        // 判断小程序打开
        if (this.isMiniOpen()) {
          result.push(list.wxmini)
        } else {
          result.push(list.wxwap)
        }
        //微信外部(h5)支付
      } else {
        result.push(list.zfb)
        if (!this.isJbcZsbBrand && !this.isJbcShanganBrand) {
          result.push(list.wxh5)
        }
      }
      return result
    },
    ...mapGetters('recommendCode', ['getRecommendCode']),
    //订单准备接口参数
    orderPrepareFixedParam() {
      return function () {
        let query = this.routeFixedParam()
        query.product_list = this.getCreateParamProductList()
        query.address = this.currentAddress

        if (this.$route.query.type) {
          query.type = 'advclass'
        }
        return query
      }
    },
  },
  methods: {
    // 检测页面参数
    checkPageParam() {
      // 页面跳转固定参数
      let query = this.routeFixedParam(),
        shoppingInfor = getShoppingInfor()

      // 检查商品信息是否完整
      if (shoppingInfor) {
        // 当token不存在的时候 跳转登录页面
        if (!getToken()) {
          this.$router.push({ name: 'login', query })
          return
        }
      } else {
        this.requestFailedJump()
        return
      }
      this.initCouponsAndRecommendCode()
      let json_shopping = shoppingInfor,
        json_orderShopping = getPayOrderNo().value
      if (json_orderShopping && json_shopping !== json_orderShopping) {
        removePayOrderNo()
      }

      this.getAddressList().then(() => {
        this.getOrderPrepare()
      })
      this.getCouponsPrepare()
    },
    // 获取地址列表
    getAddressList() {
      return addressList(this.routeFixedParam()).then((res) => {
        this.addrList = res.data
      })
    },

    // 获取交易信息
    getOrderPrepare() {
      const query = this.orderPrepareFixedParam()
      this.recommend_code && (query.recommend_code = this.recommend_code)
      this.couponsArray.length && (query.coupons = this.couponsArray)

      orderPrepare(query).then((res) => {
        // 请求成功
        if (res.status === 1) {
          let resData = res?.data
          this.products = resData.products
          this.total = resData.total
          this.pageLoadingComplete = true
          this.has_express = resData.has_express
          this.has_coupons = resData.has_coupons
          this.has_recommend = resData.recommend.has_recommend

          if (this.couponsArray.length > 0 && resData.coupons?.length > 0) {
            if (
              JSON.stringify(this.couponsArray.sort()) !== JSON.stringify(resData.coupons?.sort())
            ) {
              this.updateCouponsArray(resData.coupons)
            }
          }
          if (this.recommend_code) {
            this.initRecommendCode()
          }

          setPayProducts(resData.products)
        } else {
          this.removePaymentRecommendCodeAndCoupons()
          if (res?.message?.indexOf('优惠券') >= 0 || res?.message?.indexOf('推荐码') >= 0) {
            this.recommend_code = ''
            this.couponsArray = []

            this.getOrderPrepare()
            return false
          }

          res.message && this.$toast(res.message)

          setTimeout(() => {
            this.requestFailedJump()
          }, 1000)
        }
      })
    },

    // 检查订单信息
    checkPaymentOrder() {
      let param = this.routeFixedParam()
      param.no = getPayOrderNo().key

      return new Promise((resolve) => {
        checkPaymentResult(param).then((res) => {
          // 0等待支付,1支付处理中,2支付成功,5订单处理中，9已退款
          //支付成功调用
          if (res?.data?.order_status === 2) {
            // 关闭弹窗
            this.showDialog = false
            this.removePaymentRecommendCodeAndCoupons()
            this.executeBuySuccessFn()

            return
          }
          resolve(res)
        })
      })
    },

    // 获取设备参数
    getDeviceParam() {
      let type = this.playTypeRsult,
        result = {}

      switch (type) {
        case 'zfb':
          result = this.paramZfb()
          break
        case 'wxwap':
          result = this.paramWxWap()
          break
        case 'wxh5':
          result = this.paramWxH5()
          break
        case 'wxmini':
          result = this.paramWxMini()
          break
      }
      return result
    },
    // 获取参数 product_list
    getCreateParamProductList() {
      try {
        return JSON.parse(getShoppingInfor())
      } catch (error) {
        removeShoppingInfor()
        return ''
      }
    },
    // 生成创建订单请求参数
    getOrderCreateParam() {
      // 设备参数
      let deviceParam = this.getDeviceParam()
      // 支付回调地址
      let paymentCallURL = this.paymentCallURL + '&showDialog=true&noCheckOrder=true'
      // 请求公共参数
      let param = this.routeFixedParam(deviceParam.param)
      param.product_list = this.getCreateParamProductList()
      param.address = this.currentAddress

      this.recommend_code && (param.recommend_code = this.recommend_code)
      this.couponsArray.length && (param.coupons = this.couponsArray)

      // 支付失败回调地址
      param.quitUrl = paymentCallURL
      // 支付成功回调地址
      param.returnUrl = this.paymentSuccessURL
      // 请求后回调函数
      let call = deviceParam.call
      return { param, call }
    },

    // 订单创建请求
    orderCreate() {
      let generateOrderCreateParam = this.getOrderCreateParam(),
        param = generateOrderCreateParam.param,
        call = generateOrderCreateParam.call

      if (this.has_express === 1 && !param.address) {
        this.$toast('请填写收货地址')
        return
      }

      if (this.$route.query.type) {
        param.type = 'advclass'
      }
      this.isDisableButton = true
      orderCreatePayment(param).then((res) => {
        let payData = res?.data?.pay_data,
          no = res?.data?.no
        setTimeout(() => {
          this.isDisableButton = false
        }, 4000)

        // 请求失败时返回给出相应提示
        if (res.status !== 1) {
          this.$toast(res?.message)
          return
        }

        // 余额支付时直接进行跳转
        if (payData?.buy === true) {
          this.showToastLoading()
          setTimeout(() => {
            this.executeBuySuccessFn()
          }, 2000)
          return
        }

        // 写入订单号
        setPayOrderNo(no, getShoppingInfor())
        // 支付后 支付回调url写入开启弹窗
        this.paymentCallURL = this.paymentCallURL + '&showDialog=true&noCheckOrder=true'

        // 两秒后打开弹窗
        setTimeout(() => {
          // 打开弹窗
          this.showDialog = true
        }, 2000)

        // 执行支付参数回调
        call(payData, no)
      })
    },

    // 执行购买成功方法
    executeBuySuccessFn() {
      this.$toast('购买成功')
      setTimeout(() => {
        this.toPaymentSuccessURL()
      }, 2000)
    },

    // 加载中提示
    showToastLoading() {
      this.$toast.loading({
        duration: 2000,
        message: '加载中...',
        forbidClick: true,
      })
    },

    // 支付宝
    paramZfb() {
      let param = this.paymentParam.zfb
      let call = (data) => {
        let order_info = data?.order_info
        const div = document.createElement('div')
        /* 此处form就是后台返回接收到的数据 */
        div.innerHTML = order_info
        document.body.appendChild(div)
        document.forms[0].submit()
      }
      return { param, call }
    },

    // 微信外打开
    paramWxH5() {
      let param = this.paymentParam.wxh5
      let call = (data) => {
        let path = data.mweb_url
        path += '&redirect_url=' + encodeURIComponent(this.paymentCallURL)
        console.log(path)

        this.$util.windowLocationHref(path)
      }
      return { param, call }
    },

    // 微信内部打开
    paramWxWap() {
      let param = this.paymentParam.wxwap
      param.openid = this.$route.query.openId
      let call = (data) => {
        jsApiCall(data)
      }
      return { param, call }
    },

    // 微信小程序
    paramWxMini() {
      let param = this.paymentParam.wxmini
      if (getRequestAppType()) {
        param.mptype = getRequestAppType()
      }
      let call = (data, no) => {
        // this.openResultSelectTimer()
        let pay_data = data
        window.wx.miniProgram.navigateTo({
          url: `/pages/webview/buying/index?orderNo=${no}&timeStamp=${
            pay_data.timeStamp
          }&package=${encodeURIComponent(pay_data.package)}&nonceStr=${pay_data.nonceStr}&paySign=${
            pay_data.paySign
          }`,
        })
      }
      return { param, call }
    },

    // 请求失败跳转
    requestFailedJump() {
      let beforeRouteFullPath = this.$route.query.beforeRouteFullPath
      // 有指定路径跳转指定路径
      if (beforeRouteFullPath) {
        this.$router.replace({ path: beforeRouteFullPath })

        // 否则跳转缺省页
      } else {
        this.$router.replace({
          name: 'emptyContent',
          query: { url: this.$route.fullPath },
        })
      }
    },

    // 跳转支付成功页面
    toPaymentSuccessURL() {
      if (this.isMiniOpen()) {
        removePayOrderNo()
        wx.miniProgram.navigateBack()
        return
      }

      window.location.replace(this.paymentSuccessURL)
    },

    // 获取支付成功url
    getPaymentSuccessURL() {
      let beforeRouteFullPath = this.$route.query.beforeRouteFullPath
      const result =
        window.location.origin +
        this.$router.resolve({ path: '/pay/payment_success', query: { beforeRouteFullPath } }).href
      return result
    },
    // 进行购买
    buy() {
      // 检查当前订单是否完成
      this.checkPaymentOrder().then((res) => {
        let resData = res?.data,
          order_status = resData?.order_status,
          order_msg = resData?.order_msg

        if (order_status === 0 || res?.status !== 1) {
          this.orderCreate()
        } else {
          if (order_msg) {
            this.$toast(order_msg)
          } else {
            this.$toast('网络请求异常')
          }
        }
      })
    },
    // 检查支付结果
    finishButtonClick() {
      this.checkPaymentOrder().then((res) => {
        let msg = res.data.order_msg
        // 提示支付信息
        if (msg) {
          this.$toast(msg)
        }
      })
    },

    // 开启结果轮询定时器
    openResultSelectTimer() {
      if (this.resultSelectTimer) {
        return false
      }
      this.resultSelectTimer = setInterval(() => {
        this.checkPaymentOrder()
      }, 3000)
    },

    // 判断小程序打开
    isMiniOpen() {
      return getPaySuccessURL() === 'mpopen'
    },

    // 跳转地址编辑
    toAddressEdit() {
      let query = this.routeFixedParam()
      this.$router.push({ path: '/address/list', query })
    },
    // 页面显示时调用
    handleVisiable() {
      // 检查订单是否完成
      // if (this.showDialog) {
      //   this.checkPaymentOrder()
      // }
    },

    initRecommendCode() {
      if (/^\d{6}$/.test(this.recommend_code)) {
        // 确保组件已挂载
        this.$nextTick(() => {
          if (this.$refs.codePicker) {
            // 分解推荐码到captchas数组
            this.$refs.codePicker.captchas = this.recommend_code.split('').map((num) => ({ num }))
          }
        })
      }
    },
  },

  mounted() {
    // 初始化当前选择
    this.playTypeRsult = this.playTypeListArray[0].value

    // 用户通过回调进入 显示弹窗
    if (this.$route.query.showDialog) {
      this.showDialog = true
    }

    // 写入支付回调地址
    this.paymentCallURL = window.location.href

    this.paymentSuccessURL = this.getPaymentSuccessURL()
    if (this.getRecommendCode?.rcode) {
      this.recommend_code = this.getRecommendCode.rcode
    }

    // 检查页面参数
    this.checkPageParam()

    if (this.isMiniOpen()) {
      this.finishButtonClick()
    }
    document.addEventListener('visibilitychange', this.handleVisiable)
  },
}
</script>

<style lang="scss" scoped>
.container-wrapper {
  padding-bottom: 2.2rem;
  box-sizing: border-box;
  min-height: 100vh;
}

.card {
  background-color: #fff;
  overflow: hidden;

  & + & {
    border-top: 0.32rem solid #f7f8fa;
  }

  &-title {
    font-size: 0.43rem;
    line-height: 1;
    color: #333333;
    margin-top: 0.43rem;
    font-weight: bold;
    padding: 0 $containerPadding;
  }
}

.infor {
  &-list {
    > li + li {
      border-top: 1px solid #ebecf0;
    }

    &-item {
      padding: 0.5rem 0;

      .name {
        color: #333333;
        font-size: 0;
        margin-bottom: 0.2rem;

        > span {
          vertical-align: middle;
        }

        .lable {
          float: left;
          margin-top: 0.05rem;
          display: block;
          padding: 0 0.1rem;
          height: 0.45rem;
          line-height: 0.45rem;
          font-size: 0.29rem;
          border-radius: 0.05rem;
          background: #8f97a8;
          color: #fff;
          margin-right: 0.2rem;
        }

        .text {
          font-size: 0.4rem;
          line-height: 0.56rem;
        }
      }

      .detail {
        .text {
          margin-right: 0.45rem;
          display: inline-block;
          font-size: 0.32rem;
          line-height: 0.45rem;
          color: #919499;
        }
      }
    }
  }
}

.ksii-group {
  padding-top: 0.2rem;
  padding-bottom: 0.2rem;

  .price {
    font-size: 0.53rem;
    font-weight: 500;
    color: #ff6a4d;

    .symbol {
      font-size: 0.37rem;
    }

    .number {
      font-size: 0.6rem;
    }
  }
}

.playtype {
  padding: 0.3rem 0;

  .van-cell {
    min-height: 0.88rem;
    padding: 0.2rem $containerPadding;
    align-items: center;
  }

  /deep/ .van-cell__left-icon {
    width: 0.32rem;
    height: 0.32rem;
    margin-right: 0.12rem;
    line-height: 0.32rem;
  }

  /deep/ .van-radio {
    display: flex;
    align-items: center;
  }
}

.explain {
  padding-top: 0.45rem;
  padding-bottom: 0.3rem;

  &-text {
    font-size: 0.35rem;
    line-height: 0.48rem;
    color: #919499;

    & + & {
      margin-top: 0.43rem;
    }
  }
}

.play-button {
  position: fixed;
  left: 0;
  bottom: 0;
  width: 100%;
  background-color: #fff;
  z-index: 1;
  padding-top: 0.43rem;
  padding-bottom: 0.6rem;
  @include maxWidth();

  .button {
    width: 100%;
  }
}

.address {
  display: flex;
  justify-content: space-between;
  align-items: center;
  min-height: 2rem;
  position: relative;
  background-color: #fff;

  &::after {
    content: '';
    position: absolute;
    bottom: 0;
    left: 3%;
    background-image: url(../../assets/images/goods/play_line.png);
    background-size: 100%;
    width: 94%;
    height: 0.05rem;
    background-repeat: no-repeat;
  }

  .van-icon-arrow {
    font-size: 0.4rem;
    color: #c2c5cc;
  }

  &-content {
    max-width: 6.8rem;
  }

  &-edit {
    padding: 0.4rem 0;

    .name {
      font-size: 0.43rem;
      font-weight: bold;
      color: #18191a;
      margin-bottom: 0.3rem;

      > span + span {
        margin-left: 0.45rem;
      }
    }

    .text {
      font-size: 0.32rem;
      line-height: 0.45rem;
      color: #333333;
    }
  }

  &-add {
    .name {
      display: flex;
      align-items: center;
      justify-content: flex-start;
      font-size: 0.4rem;

      .icon {
        width: 0.4rem;
        margin-right: 0.2rem;
      }
    }
  }
}

.grey {
  @include flex_align_center;
  font-size: 0.347rem;
  color: #c2c5cc;
  cursor: pointer;

  .grey-img {
    display: inline-block;
    width: 0.14rem;
    margin-left: 0.107rem;
  }
}

.dialog-pay {
  border-radius: 0.2rem;
  width: 8rem;
  padding: 0 1rem;
  padding-bottom: 0.5rem;
  box-sizing: border-box;
  overflow: initial;

  /deep/ .van-dialog__header {
    padding-top: 0.787rem;
    font-size: 0.427rem;
    line-height: 1;
    color: #22242e;
    margin-bottom: 0.8rem;
  }

  .button {
    font-size: 0.373rem;
    color: #ffffff;
    margin-bottom: 0.267rem;

    &-kefu {
      @include flex_center;
      height: 1.067rem;
      border-radius: 0.533rem;
      border: solid 1px #ebecf0;
      color: #3c3d42;

      .text {
        color: #13bf80;
      }
    }
  }

  .close-icon {
    @include position_centerX;
    bottom: -1.2rem;
    width: 0.747rem;
    height: 0.747rem;
  }
}
</style>
